import { CurrencyCode } from '../constants/currencies';
import { formatCurrency } from '../utils/formatters';
import { SettlementSummary as SettlementSummaryData } from '../utils/settlementCalculator';
import { ChevronDown } from 'lucide-react';

interface SettlementSummaryProps {
  summary: SettlementSummaryData;
  currency: CurrencyCode;
}

const SettlementSummary = ({ summary, currency }: SettlementSummaryProps) => {
  const rows = [
    { label: '내가 낸 금액(+)', amount: summary.paid, color: 'text-blue-500' },
    { label: '내가 쓴 금액(-)', amount: summary.spent, color: 'text-red-500' },
    { label: '보낸 금액(+)', amount: summary.sent, color: 'text-blue-500' },
    { label: '받은 금액(-)', amount: summary.received, color: 'text-red-500' },
  ];
  // 송금 카드의 정산 완료 판정과 같은 오차 범위를 적용합니다.
  const balance = Math.abs(summary.balance) > 0.01 ? summary.balance : 0;
  const totalLabel = balance > 0 ? '총 받을 금액' : balance < 0 ? '총 보낼 금액' : '남은 정산 금액';
  const totalColor = balance > 0 ? 'text-blue-500' : balance < 0 ? 'text-red-500' : 'text-gray-800';

  return (
    <details className="group rounded-lg border border-gray-100 bg-white">
      <summary className="flex cursor-pointer list-none items-center justify-between gap-3 px-4 py-3 text-base font-bold text-gray-800 [&::-webkit-details-marker]:hidden">
        <span>왜 이런 정산 결과가 나왔나요?</span>
        <ChevronDown aria-hidden="true" className="h-5 w-5 shrink-0 transition-transform group-open:rotate-180" />
      </summary>
      <dl className="space-y-3 px-4 pb-4 pt-1 text-sm">
        {rows.map(row => (
          <div key={row.label} className="flex items-center justify-between gap-3">
            <dt className="text-gray-600">{row.label}</dt>
            <dd className={`font-semibold font-mono-number ${row.color}`}>
              {formatCurrency(row.amount, currency)}
            </dd>
          </div>
        ))}
        <div className="flex flex-wrap items-center justify-between gap-2 border-t border-gray-100 pt-4 !mt-4">
          <dt className="text-lg font-bold text-gray-900">{totalLabel}</dt>
          <dd className={`text-lg font-bold font-mono-number ${totalColor}`}>
            {formatCurrency(Math.abs(balance), currency)}
          </dd>
        </div>
      </dl>
    </details>
  );
};

export default SettlementSummary;
